import styled from 'styled-components';
const HeaderIconWrapper = styled.div.withConfig({
  displayName: "HeaderIconWrapper",
  componentId: "sc-1hp1396-0"
})(["display:flex;align-items:center;"]);
export default HeaderIconWrapper;